import FilterChipMixin from './mixin.js';

const date_time_filter_chip_comp = {
  mixins: [FilterChipMixin],

  computed: {
    text_value: function() {
      var value;

      value = _.clone(this.filter.value);
      if (value.dynamic) {
        value.lft = Skylark.Helpers.Utilities.stringifyFilter(value.lft);
        value.rgt = Skylark.Helpers.Utilities.stringifyFilter(value.rgt);
      }

      if (value.lft && value.rgt) {
        return `${value.lft} ~ ${value.rgt}`;
      } else {
        if (value.lft) {
          return `${value.lft} 之后`;
        } else if (value.rgt) {
          return `${value.rgt} 之前`;
        } else {
          return '';
        }
      }
    }
  }
};

export {
  date_time_filter_chip_comp as DateTimeFilterChip,
  date_time_filter_chip_comp as HoldCreatedAtFilterChip,
  date_time_filter_chip_comp as YAW__JourneyCreatedAtFilterChip
};
